

import React, {useEffect} from 'react';
import { useArcAuth, RequireAuth } from '@arcauth/react-sdk';
import { useNavigate, useParams } from 'react-router-dom';
import { decodeURL, decryptAES } from '../../shared/util/encrypt.decrypt';
import { pageTypeConfig, getClientConfig } from '../../config/app';
import { useDispatch, useSelector } from 'react-redux';
import { setClientConfigData } from '../../redux/features/client.configSlice';
import { getCookie, removeCookie, setCookie } from '../token';
import Box from '@mui/material/Box';
import { RootStateType } from '../../redux/features/rootSlice';
import { Stack, Typography } from '@mui/material';
import RedirectIcon from '../../shared/icon/redirect-icon';


const Redirect = () => {
    // Pull user/authentication/loading state from ArcAuth context
    const { isAuthenticated, isLoading, login } = useArcAuth();
    const navigate = useNavigate();
    const params = useParams();
    const dispatch=useDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    let pageType:string = urlParams?.get('page_type')||'';
    //let pageType = decodeURL(encryptedPageType ??'');
    const code = useSelector((state: RootStateType) => state.deviceConfigReducer.code);
    const clientType = useSelector((state: RootStateType) => state.deviceConfigReducer.clientType);
    const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
    if (pageType !== null && pageType in pageTypeConfig) {
        pageType = pageType;
      } else {
        // Handle the case where pageType is null or not found in pageTypeConfig
        pageType = '';
      }


      useEffect(() => {
        if (!isAuthenticated) {
            if (code) {
                // Nonce detected: Clear specific storage and process nonce login
                localStorage.removeItem("deviceConfigReducer");
                const userObject = { user: { nonce_authenticator: code, prompt: 'login' } };
                // console.log("Nonce detected for unauthenticated user:", userObject);
                login(userObject.user, '');
            } else {
                // Normal login flow for unauthenticated users
                login();
            }
        } else {
            if (code) {
                // Nonce detected for authenticated user: Force logout and process nonce login
                removeCookie('lastState=', 0, storedClientId);
                removeCookie('user=', 0, storedClientId);
                setCookie('app.at_exp=', 0, storedClientId);
                setCookie('app.at=', 0, storedClientId);
                setCookie('app.rt=', 0, storedClientId);
    
                // Clear all localStorage keys except the one to keep
                const keyToKeep = 'configStateReducer';
                Object.keys(localStorage).forEach(key => {
                    if (key !== keyToKeep) {
                        localStorage.removeItem(key);
                    }
                });
    
                const userObject = { user: { nonce_authenticator: code, prompt: 'login' } };
                // console.log("Nonce detected for authenticated user:", userObject);
                login(userObject.user, '');
            } else {
                // Normal flow for authenticated users
                navigate(`/${pageType}`);
            }
        }
    }, [isAuthenticated]);
    
    

    // if (!isAuthenticated || isLoading) {
    //     return null;
    // }
    return (
        <>
     <Box sx={{position: 'fixed', left: 0, top: 0, width: '100%', height: '100%', display: 'grid', placeItems: 'center', backgroundColor: '#fff', zIndex: 999999 }}>
    <Stack height={'100%'} alignItems={'center'} justifyContent={'center'}>
     <RedirectIcon />
     <Typography variant="h1" mt={2} fontSize={28} color="initial" gutterBottom>Redirecting to the web application...</Typography>
     <Typography variant="h5" fontSize={16} fontWeight={'normal'} color="initial">Please wait while we securely verify your session.</Typography>
    </Stack>
    </Box>
 </>

    );
};

export default Redirect;
